import Title from '@/components/base/Title/Title';
import Module from '@/components/base/Module/Module.vue';
import HorizontalScroll from '@/components/base/HorizontalScroll/HorizontalScroll.vue';
import SecondKillItem from '@/components/item/SecondKillItem/SecondKillItem';
import baseMixin from "../baseMixin";
import AskFollow from '@/components/item/SecondKillItem/AskFollow/AskFollow';
export default {
  mixins: [baseMixin],
  props: {
    data: {
      required: true
    }
  },
  data: function data() {
    return {
      showAskFollowModalActId: 0
    };
  },
  components: {
    SecondKillItem: SecondKillItem,
    Module: Module,
    HorizontalScroll: HorizontalScroll,
    Title: Title,
    AskFollow: AskFollow
  },
  computed: {
    now: function now() {
      return this.$store.state.nowTimestamp;
    },
    // 已结束活动置后
    killList: function killList() {
      var normalList = [];
      var expiredList = [];
      for (var n = 0; n < this.data.vActList.length; n++) {
        if (this.data.vActList[n].tActState.lEndTimeStamp >= this.now) {
          normalList.push(this.data.vActList[n]);
        } else {
          expiredList.push(this.data.vActList[n]);
        }
      }
      return normalList.concat(expiredList);
    },
    // 上报数据参数
    reportParams: function reportParams() {
      return {
        f_module: '限时秒杀',
        f_module_id: this.id,
        eid: 'moudle'
      };
    }
  },
  methods: {
    findIndex: function findIndex(sActID) {
      for (var n in this.data.vActList) {
        if (this.data.vActList[n].sActID === sActID) {
          return n;
        }
      }
    },
    afterOrder: function afterOrder(_ref) {
      var actId = _ref.actId;
      this.showAskFollowModalActId = actId;
    }
  },
  ptag: 'ms',
  reportData: {
    '更多': {
      'f_module': '限时秒杀',
      'f_resource': '更多',
      'f_type': 4
    }
  }
};